"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enhanceValueItems = void 0;
/**
 * Takes the valueItems array of Partial<LineOfCoverageDetails> and enhance each item
 * to be an object that holds the original object + its id
 *
 * @param valueItems - Array of Partial<LineOfCoverageDetails>
 * @param ids - ids array where each item corresponds to the id of the valueItem on the same index
 * @param options - current options available which order should match the resulting valueItems
 */
function enhanceValueItems(valueItems, ids, options) {
    var idToValueItems = {};
    valueItems.forEach(function (valueItem, index) {
        idToValueItems[ids[index]] = valueItem;
    });
    // calculate the resulting enhanced value items according to the options order
    return options.map(function (_a) {
        var id = _a.id, type = _a.type;
        var valueItem = idToValueItems[id] || { type: type };
        return { id: id, valueItem: valueItem };
    });
}
exports.enhanceValueItems = enhanceValueItems;
